import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeliveryComponent } from './delivery.component';
import { DeliveryCreateComponent } from './delivery-create/delivery-create.component';
import { DeliveryEditComponent } from './delivery-edit/delivery-edit.component';
import { DeliveryDetailsComponent } from './delivery-details/delivery-details.component';

const routes: Routes = [{
  path: '', component: DeliveryComponent, children: [
    {path: 'create/:id', 
    component:DeliveryCreateComponent
  },
    {path: 'edit/:id', 
    component:DeliveryEditComponent
  },
    {path: 'details/:id',
    component:DeliveryDetailsComponent
  }

  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeliveryRoutingModule { }
